import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'store';
import columns from './Columns';
import MailHeader from './MailTemplatesHeader';
import { useCallback, useMemo, useState } from 'react';
import { AuthGet, AuthPatch, AuthPost, AuthPut } from 'helpers/api/AuthCRUD';
import { API } from 'helpers/api/endpoints';
import { setMailTemplates } from 'store/responseData/templatesSlice';
import { MailSendMode, TemplatesModel } from 'types';
import MailTemplateEditModal from './Component/MailTemplateEditModal';
import ExpiryDaysModal from './Component/ExpiryDaysModal';

export default function MailTemplatesTableView() {

  const { t } = useTranslation(['mailManager', 'benutzerliste']);
	const dispatch = useDispatch();
  const mailTemplates = useSelector((state: RootState) => state.mailTemplates);
  const { token } = useSelector((state: RootState) => state);

  const [selectedTemplate, setSelectedTemplate] = useState<TemplatesModel | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [expiryTemplate, setExpiryTemplate] = useState<TemplatesModel | null>(null);


  const refreshTemplates = useCallback(async () => {
    if (!token) return;
    const r = await AuthGet(API.mail.templates, token);
    if (Array.isArray(r)) dispatch(setMailTemplates(r));
  }, [token, dispatch]);

  const onToggleSendMode = useCallback(
    async (guid: string, mode: MailSendMode) => {
      if (!token) return;

      await AuthPatch(
        API.mail.sendMode(guid),
        { sendMode: mode },
        token
      );

      await refreshTemplates();
    },
    [token, refreshTemplates]
  );


  const onEdit = (template: TemplatesModel) => {
    setSelectedTemplate(template);
    setShowEditModal(true);
  };

  const cols = useMemo(() =>
      columns({
        t,
        onToggleSendMode,
        onEdit,
        onEditExpiryDays: (tpl) => setExpiryTemplate(tpl)
      }),
    [t, onToggleSendMode]
  );

  const tableData = useMemo(
    () => (Array.isArray(mailTemplates) ? mailTemplates : []),
    [mailTemplates]
  );

  return (
    <AdvanceTableWrapper
      data={tableData}
      columns={cols}
      pagination
      sortable
      perPage={10}
    >
      {showEditModal && selectedTemplate && (
        <MailTemplateEditModal
          template={selectedTemplate}
          onClose={() => setShowEditModal(false)}
          onSaved={refreshTemplates}
        />
      )}

      {expiryTemplate && (
        <ExpiryDaysModal
          template={expiryTemplate}
          show={true}
          onClose={() => setExpiryTemplate(null)}
          onSave={async (guid, days) => {
            if (!token) return;

            await AuthPut(
              API.mail.updateTemplate(guid),
              {
                ...expiryTemplate,
                expiryWarningDays: days
              },
              token
            );
            setExpiryTemplate(null);
            await refreshTemplates();
          }}
        />
      )}

      <Row className="gx-3">
        <Col>
          <Card>
            <Card.Header className="border-bottom border-200 px-0">
              <MailHeader 
              //@ts-ignore
              table />
            </Card.Header>

            <Card.Body className="p-0">
              <AdvanceTable
              //@ts-ignore
                table
                  headerClassName="bg-light text-800 align-middle"
                  rowClassName=" align-middle white-space-nowrap hover-actions-trigger btn-reveal-trigger hover-bg-100"
                  tableProps={{
                    className: 'fs--1 mb-0 overflow-hidden',
                  }}
                />
            </Card.Body>

            <Card.Footer>
              <AdvanceTablePagination 
              //@ts-ignore
              table />
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </AdvanceTableWrapper>
  );
}
